import { ProcessToastComponent } from "@core/components/toast/toast-message/components/process-toast/process-toast.component";
import { defineToastConfig, ToastConfig, VIEW_PORT_MARGINS } from "@core/types/toast/toast-config.types";
import { MessageToast, ProcessToast } from "./toast.types";
import { MessageToastComponent } from "@core/components/toast/toast-message/components/message-toast/message-toast.component";

export type ToastRegistry = {
  process: ProcessToast;
  message: MessageToast;
};
export const TOAST_CONFIG: ToastConfig<ToastRegistry> = defineToastConfig<ToastRegistry>(
  {
    maxNumberOfToasts: 8,
    overlayPosition: {
      verticalPosition: {
        alignment: VIEW_PORT_MARGINS.TOP,
        value: "100px"
      },
      horizontalPosition: {
        alignment: VIEW_PORT_MARGINS.RIGHT,
        value: "16px"
      }
    },
    renderers: {
      process: {
        component: ProcessToastComponent,
        kind: "process",
        mapInputs: (payload: ProcessToast) => ({
          process: payload.process
        })
      },
      message: {
        component: MessageToastComponent,
        kind: "message",
        mapInputs: (payload: MessageToast) => ({
          title: payload.title,
          localizedTitle: payload.localizedTitle,
          text: payload.text,
          localizedText: payload.localizedTitle
        })
      }
    }
  }
);
